import star from "../../assets/img/star.svg";
import emptyStar from "../../assets/img/empty-star.svg";

// render stars dynamically 
export const renderAllStars = (rating) => {
    const renderStars = (rating) => {
        return [...Array(rating)].map((s, i) => <img src={star} key={`filledstar${i}`} alt="filled star" className="star icon" />)
    }

    const renderEmptyStars = (rating) => {
        return [...Array( 5 - rating)].map((s, i) => <img src={emptyStar} key={`emptystar${i}`} alt="empty star" className="star icon" />)
    }

    if (rating === 5) {
          return renderStars(5)
    } else if (isNaN(rating)){
          return renderEmptyStars(0)
    } else {
         return renderStars(rating).concat(renderEmptyStars(rating))
    }
}